import { useState } from "react"
import ModalConfirm from "../../components/Display/ModalConfirm"
import Button from "../../components/General/Button"

const PriceAdjustForm: React.FC<PriceAdjustProps> = ({
  makeAdjustment,
  onCancel
}) => {

  const [adjustValue, setAdjustValue] = useState<number>(0)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const handleChange = (e) => {
    const value = +e.target.value
    if (value > 100) setAdjustValue(100)
    else if (value < -50) setAdjustValue(-50)
    else setAdjustValue(value)
  }

  return (
    <>
      <h4 className="text-primary-900 font-bold dark:text-white">
        Ajustar Precio Globalmente
      </h4>
      <input 
        type="number" 
        value={String(+adjustValue)} 
        onChange={handleChange} 
        className="dark:bg-gray-600 dark:border-gray-600 dark:text-white text-right h-7 my-3"
        style={{ width: '64px' }}
        min="-50"
        max="100"
      /> %
      <input
        style={{ width: "100%" }}
        className="text-red"
        type="range"
        min="-50"
        max="100"
        value={adjustValue}
        onChange={handleChange}
      />
      <div className="flex flex-row justify-around mx-auto w-10/12 mt-4 mb-2">
        <Button
          type="outline"
          isIconLeft={false}
          classes="w-2/5"
          onClick={() => onCancel()}
        >
          Cancelar
        </Button>
        <Button
          type="primary"
          classes="w-2/5"
          onClick={() => setShowConfirmModal(true)}
          disabled={adjustValue === 0}
        >
          Ajustar
        </Button>
      </div>

      <ModalConfirm
          title="¿Está seguro que desea ajustar masivamente los precios? La confirmación del mismo es una acción irreversible"
          displayConfirmModal={showConfirmModal}
          onCancel={() => setShowConfirmModal(false)}
          onConfirm={async () => {
            makeAdjustment(adjustValue)
          }}
        />
    </>
  )
}

export default PriceAdjustForm

interface PriceAdjustProps {
  makeAdjustment: Function
  onCancel: Function
}